









































































import { snakeCase } from 'lodash'
import Vue from 'vue'
import i18n from 'vue-i18n'
import { Component, Prop } from "vue-property-decorator"
import { DirectiveBinding } from 'vue/types/options'

import { SuccessChannelInfo } from '../../../../../../../../../../models/CheckChannels/CheckChannels'
import FileApi from "../../../../../../../../../File/logic/file-api";
import { RowButtonView } from '../../../../../../../components'
import CustomEditor from '../../../../../../Editor/CustomEditor'
import ChannelsInfoHelper from '../../../../../../Helpers/ChannelsInfoHelper'
import { ActionNode } from '../../../logic/ActionNode'
import { NotifyGroupActionProxy } from '../../../logic/Actions/NotifyGroupAction/NotifyGroupActionProxy'

@Component({
  data() {
    return {
      snakeCase,
    }
  },
  components: {
    RowButtonView,
  }
})
export default class NotifyGroupAction extends Vue {
  @Prop() action!: NotifyGroupActionProxy

  @Prop() i18n!: i18n

  @Prop() target!: string

  @Prop() node!: ActionNode

  @Prop() bindSocket!: DirectiveBinding

  @Prop() editor!: CustomEditor

  fileApi = new FileApi()

  get channel(): SuccessChannelInfo | undefined {
    if (this.action.action.group) {
      const info = ChannelsInfoHelper.GetChannel(String(this.action.action.group))

      return info instanceof SuccessChannelInfo ? info : undefined
    }

    return undefined
  }
}
